import React from 'react';

export type TriggerComponent = React.FC

const Trigger: TriggerComponent = ({ children }) => <>{children}</>;

Trigger.displayName = 'Trigger';

export default Trigger
